import { BriefcaseIcon } from "@heroicons/react/24/outline";
import { FC, useState } from "react";
import useSuperAdmin from "../../users/permissions/useSuperAdmin";
import LuggageDetailsModal from "./LuggageDetailsModal";

interface ILuggageBadgeProps {
  uniqueJourneyId?: string;
  onSuccess?: () => void;
}

const pill =
  "inline-flex items-center gap-1 bg-primary/10 text-primary px-2 py-0.5 rounded text-xs";

const LuggageBadge: FC<ILuggageBadgeProps> = ({ uniqueJourneyId, onSuccess }) => {
  const isSuperAdmin = useSuperAdmin();
  const [show, setShow] = useState(false);

  // Regular admins (or missing id): informational, non-clickable pill.
  if (!isSuperAdmin || !uniqueJourneyId) {
    return (
      <div className="flex gap-1 mt-1 justify-end">
        <div className={pill}>
          <BriefcaseIcon className="w-3 h-3 text-primary" />
          <span>Valixhe</span>
        </div>
      </div>
    );
  }

  // SuperAdmin: clickable → opens the details modal. stopPropagation so a click on a
  // reservation card (list view) does not also trigger the card's navigate-to-edit.
  return (
    <span
      className="flex gap-1 mt-1 justify-end"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        onClick={() => setShow(true)}
        className={`${pill} cursor-pointer hover:bg-primary/20 focus:outline-none`}
      >
        <BriefcaseIcon className="w-3 h-3 text-primary" />
        <span>Valixhe</span>
      </button>
      {show && (
        <LuggageDetailsModal
          show={show}
          onClose={() => setShow(false)}
          uniqueJourneyId={uniqueJourneyId}
          onSuccess={onSuccess}
        />
      )}
    </span>
  );
};

export default LuggageBadge;
